module.exports = __webpack_public_path__ + "img/pay-logo-wx.3e14cd67.png";